import { initialState } from '../reducers/help';
import { peek, selector } from '../selectorHelpers';

export const selectHelp = (state) => state.get('help', initialState);

// KB Helpers
export const helpSelectKbHelpers = selector(selectHelp, peek('kbHelpers'));
export const helpSelectIsKbHelpersLoading = selector(
  selectHelp,
  peek('isKbHelpersLoading'),
);

// Full knowledge base
export const helpSelectKnowledgeBaseLoading = selector(
  selectHelp,
  peek('isKnowledgeBaseLoading'),
);

export const helpSelectKnowledgeBaseLocaleLoaded = selector(
  selectHelp,
  peek('kbLocaleLoaded'),
);

export const helpSelectKbSections = selector(selectHelp, peek('kbSections'));

export const helpSelectKnowledgeBaseSectionsLoading = selector(
  selectHelp,
  peek('isKnowledgeBaseSectionsLoading'),
);

export const helpSelectKbSectionsContent = selector(
  selectHelp,
  peek('kbSectionsContent'),
);
